import { cn } from 'utils/cn';
import { HourglassLoader } from 'components/atoms/spinner/HourglassLoader';
import { localize } from 'i18n/localize';

const $t = localize();

type Props = {
	className?: string;
};

export function ProcessingVideoOverlay({ className }: Props) {
	return (
		<div className={cn('flex flex-col gap-3 items-center text-dark-blue-50 text-sm', className)}>
			<HourglassLoader color="#AAAEB3" />
			{$t.offer.videoProcessing}
		</div>
	);
}
